<template>
  <div class="child-pages-navigation">
    <child-pages-navigation-link icon-name="icon-searches"
                                 :text="$t('searches')"
                                 :location="getLocation('children.single.searches')" />

    <child-pages-navigation-link icon-name="icon-location"
                                 :text="$t('tabs.location.title')"
                                 :location="getLocation('children.single.location')" />

    <child-pages-navigation-link icon-name="icon-screen-time"
                                 :text="$t('tabs.screentime.title')"
                                 :location="getLocation('children.single.screenTime')" />

    <child-pages-navigation-link icon-name="icon-youtube"
                                 :text="$t('tabs.youtube.title')"
                                 :location="getLocation('children.single.youtube')" />

    <child-pages-navigation-link icon-name="icon-block-shield"
                                 :text="$t('tabs.blocksAlerts.title')"
                                 :location="getLocation('children.single.blocksAndAlerts')" />
  </div>
</template>

<script>
  import ChildPagesNavigationLink from './ChildNavigationLink.vue'

  export default {
    props: {
      childId: {
        required: true
      }
    },

    components: {
      ChildPagesNavigationLink
    },

    methods: {
      getLocation(name) {
        return {
          name,
          params: {
            id: this.childId
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .child-pages-navigation {
    position: relative;
    display: flex;
    width: 100%;
    box-shadow: 0 0 8px 0 rgba(#000, .1);
    z-index: 1; // to always show box-shadow
  }
</style>
